import React, { useState, useEffect } from 'react'
import { Fragment } from 'react';
import { TabView, TabPanel } from "primereact/tabview";
import ProjectReport from './project-report';
import UserReport from './user-report';
import DayWiseTimesheet from './day-wise-timesheet';
import {
    REPORT_USER_MENU_VIEW, REPORT_PROJECT_MENU_VIEW, REPORT_DAY_WISE_TIMESHEET_MENU_VIEW
} from '../../config/permissions';
import ProtectedSection from "../../components/protected/ProtectedSection";
import { hasPermission } from "../../components/protected/ProtectedSection";

export const Report = () => {
    const [activeIndex, setActiveIndex] = useState(1);
    const [items, setItems] = useState([])

    useEffect(() => {
        const fItems = ([
            { label: 'Users ', icon: 'pi pi-users', permissions: REPORT_USER_MENU_VIEW },
            { label: 'Projects', icon: 'pi pi-users', permissions: REPORT_PROJECT_MENU_VIEW },
            { label: 'Day Wise Timesheet', icon: 'pi pi-book', permissions: REPORT_DAY_WISE_TIMESHEET_MENU_VIEW },
        ]);
        setItems(fItems);
    }, [])

    const ActiveTab = () => {
        switch (activeIndex) {
            case 0:
                return <ProtectedSection permissions={[REPORT_USER_MENU_VIEW]}><UserReport /></ProtectedSection>;
            case 1:
                return <ProtectedSection permissions={[REPORT_PROJECT_MENU_VIEW]}><ProjectReport /></ProtectedSection>;
            case 2:
                return <ProtectedSection permissions={[REPORT_DAY_WISE_TIMESHEET_MENU_VIEW]}><DayWiseTimesheet /></ProtectedSection>;
            default:
                return <ProtectedSection permissions={[REPORT_USER_MENU_VIEW]}><UserReport /></ProtectedSection>;
        }
    }

    const getTabBody = (tab) => {
        return (
            <div>
                <span className={tab.icon} style={{ marginRight: "3%" }}></span>
                {tab.label}
            </div>
        );
    };

    return (

        <Fragment>
            <div className="card">
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    {items.map((tab) => {
                        return (
                            <TabPanel key={tab.label} header={getTabBody(tab)} disabled={!hasPermission(tab.permissions)}>
                                <p className="m-0">
                                    <ActiveTab />
                                </p>
                            </TabPanel>
                        );
                    })}
                </TabView>
            </div>
        </Fragment>
    )
}